var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_737_7794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.93329 4.74077L5.10412 8.56994C4.63502 9.03904 3.99878 9.30258 3.33537 9.30258C2.67196 9.30258 2.03573 9.03904 1.56662 8.56994C1.09752 8.10084 0.833984 7.4646 0.833984 6.80119C0.833984 6.13778 1.09752 5.50154 1.56662 5.03244L5.39579 1.20327C5.70853 0.890536 6.13268 0.714844 6.57496 0.714844C7.01723 0.714844 7.44139 0.890536 7.75412 1.20327C8.06686 1.51601 8.24255 1.94016 8.24255 2.38244C8.24255 2.82471 8.06686 3.24887 7.75412 3.5616L3.92079 7.39077C3.76442 7.54714 3.55234 7.63498 3.33121 7.63498C3.11007 7.63498 2.89799 7.54714 2.74162 7.39077C2.58526 7.2344 2.49741 7.02232 2.49741 6.80119C2.49741 6.58005 2.58526 6.36797 2.74162 6.2116L6.27912 2.67827",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_737_7794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.136719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.95e2399f5cdbc360594f07e7904e2bc9.svg";
export { ForwardRef as ReactComponent };